export default __webpack_public_path__ + "static/media/weizhi.664046ae.png";